import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Wrench, RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const MaintenanceContext = createContext({ enabled: false, message: '' });
export const useMaintenance = () => useContext(MaintenanceContext);

export const MaintenanceScreen = ({ message }) => (
    <div className="min-h-screen flex items-center justify-center bg-[#064E3B] text-white p-6" data-testid="maintenance-page">
        <div className="max-w-lg text-center space-y-6">
            <div className="mx-auto h-20 w-20 rounded-full bg-white/10 flex items-center justify-center"><Wrench className="h-10 w-10" /></div>
            <h1 className="text-4xl sm:text-5xl font-bold font-['Outfit']">We'll be right back</h1>
            <p className="text-lg text-white/80">Nurulhuda Quranic School website is under maintenance. Please try again in a little while.</p>
            {message && <p className="text-base bg-white/10 rounded-lg p-4" data-testid="maintenance-message">{message}</p>}
            <button onClick={() => window.location.reload()} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-[#064E3B] font-semibold hover:bg-[#ECFDF5] transition-colors" data-testid="maintenance-retry">
                <RefreshCw className="h-4 w-4" />Try again
            </button>
        </div>
    </div>
);

// Wraps the app: polls the public maintenance flag and, for everyone except super admins, shows the maintenance page.
export const MaintenanceGate = ({ children }) => {
    const { user } = useAuth();
    const [state, setState] = useState({ enabled: false, message: '' });
    useEffect(() => {
        const check = () => axios.get(`${API_URL}/api/public/maintenance`).then(r => setState(r.data)).catch(() => {});
        check();
        const id = setInterval(check, 30000);
        const onErr = (e) => { if (e?.detail === 'maintenance') setState({ enabled: true, message: e.message || '' }); };
        const interceptor = axios.interceptors.response.use(r => r, err => { if (err.response?.status === 503 && err.response?.data?.detail === 'maintenance') onErr(err.response.data); return Promise.reject(err); });
        return () => { clearInterval(id); axios.interceptors.response.eject(interceptor); };
    }, []);
    if (state.enabled && user?.role !== 'super_admin') return <MaintenanceScreen message={state.message} />;
    return <MaintenanceContext.Provider value={state}>{children}</MaintenanceContext.Provider>;
};
